var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout" }, [
    _c("div", { staticClass: "md-layout-item" }, [
      _c("div", { staticClass: "custom-toolbar md-layout" }, [
        _c("div", { staticClass: "custom-toolbar-start" }, [
          _c(
            "div",
            { staticClass: "filter-steps--container" },
            [
              _vm.canViewTeamRegion
                ? _c("team-region-member-filter-options", {
                    attrs: {
                      "team-region-id": _vm.teamRegionId,
                      "strict-team-region-filter": false,
                      "use-elevated-filter-view": true,
                      clearable: false,
                    },
                    on: { changed: _vm.handleTeamRegionMemberChanged },
                  })
                : _vm._e(),
              _c(
                "md-field",
                { staticClass: "company-filter" },
                [
                  _c("team-member-company-dropdown-filter", {
                    attrs: {
                      placeholder: "Company",
                      "include-all": "",
                      "all-label": "All Companies",
                    },
                    on: { change: _vm.handleCompanyChanged },
                    model: {
                      value: _vm.companyName,
                      callback: function ($$v) {
                        _vm.companyName = $$v
                      },
                      expression: "companyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "md-field",
                { staticClass: "status-filter" },
                [
                  _vm.statuses
                    ? _c("vue-select", {
                        attrs: {
                          options: _vm.statuses,
                          label: "statusValue",
                          reduce: function (stat) {
                            return stat.statusId
                          },
                          placeholder: "Status",
                          searchable: _vm.$root.isDesktop,
                          clearable: false,
                        },
                        model: {
                          value: _vm.statusFilterValue,
                          callback: function ($$v) {
                            _vm.statusFilterValue = $$v
                          },
                          expression: "statusFilterValue",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "md-field",
                [
                  _c("md-datepicker", {
                    ref: "mdDatePicker",
                    staticClass:
                      "filter-steps--choices filter-step-date start-date",
                    attrs: { "md-immediately": "", "md-debounce": 100 },
                    model: {
                      value: _vm.InvoiceDateFrom,
                      callback: function ($$v) {
                        _vm.InvoiceDateFrom = $$v
                      },
                      expression: "InvoiceDateFrom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "md-field",
                [
                  _c("md-datepicker", {
                    ref: "mdDatePicker",
                    staticClass:
                      "filter-steps--choices filter-step-date end-date",
                    attrs: { "md-immediately": "", "md-debounce": 100 },
                    model: {
                      value: _vm.InvoiceDateTo,
                      callback: function ($$v) {
                        _vm.InvoiceDateTo = $$v
                      },
                      expression: "InvoiceDateTo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "md-field",
                { staticClass: "status-filter" },
                [
                  _vm.syncStatuses != null && _vm.syncStatuses.length > 0
                    ? _c("vue-select", {
                        attrs: {
                          options: _vm.syncStatuses,
                          label: "label",
                          placeholder: "Sync Status",
                          searchable: _vm.$root.isDesktop,
                          clearable: false,
                        },
                        model: {
                          value: _vm.syncStatusValue,
                          callback: function ($$v) {
                            _vm.syncStatusValue = $$v
                          },
                          expression: "syncStatusValue",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "md-field",
                { staticClass: "status-filter batch-filter" },
                [
                  _vm.batchFilterList != null && _vm.batchFilterList.length > 0
                    ? _c("vue-select", {
                        attrs: {
                          options: _vm.batchFilterList,
                          label: "label",
                          reduce: function (x) {
                            return x.id
                          },
                          placeholder: "Batch Filter",
                          searchable: _vm.$root.isDesktop,
                          clearable: true,
                        },
                        model: {
                          value: _vm.batchFilterValue,
                          callback: function ($$v) {
                            _vm.batchFilterValue = $$v
                          },
                          expression: "batchFilterValue",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "custom-toolbar-end search-container" },
          [
            _c("search-component", {
              ref: "keyword",
              attrs: { placeholder: "Search" },
              on: { onSearch: _vm.handleKeyword },
            }),
            !_vm.isTeamMember
              ? _c(
                  "md-button",
                  {
                    staticClass:
                      "md-primary md-just-icon md-round pull-right header-button",
                    attrs: { title: "Generate Invoices" },
                    on: { click: _vm.createInvoice },
                  },
                  [_c("md-icon", [_vm._v("library_add")])],
                  1
                )
              : _vm._e(),
            !_vm.isTeamMember
              ? _c(
                  "div",
                  [
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-primary md-just-icon md-round pull-right header-button",
                        attrs: {
                          title: "Export Invoices",
                          disabled: _vm.disableExport,
                        },
                        on: { click: _vm.exportInvoices },
                      },
                      [_c("md-icon", [_vm._v("get_app")])],
                      1
                    ),
                    _c(
                      "md-tooltip",
                      { class: { "hide-export-tool-tip": !_vm.disableExport } },
                      [_vm._v("No available data")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isTeamMember
              ? _c(
                  "div",
                  [
                    _vm.hasAccountingPackage
                      ? _c(
                          "md-button",
                          {
                            staticClass:
                              "md-primary md-just-icon md-round pull-right header-button",
                            attrs: {
                              title:
                                "Send data that matches the filter to Accounting Package",
                            },
                            on: { click: _vm.sendInvoicesToAccountingPackage },
                          },
                          [_c("md-icon", [_vm._v("send")])],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }